"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModuleEndpointKeys = void 0;
var ModuleEndpointKeys;
(function (ModuleEndpointKeys) {
    ModuleEndpointKeys["GetModulesByClass"] = "get.modules.byclass";
    ModuleEndpointKeys["GetModulesSummarized"] = "get.modules.summarized";
    ModuleEndpointKeys["GetPages"] = "module.getPages";
})(ModuleEndpointKeys || (exports.ModuleEndpointKeys = ModuleEndpointKeys = {}));
